import type { TicketStatus } from './schema';
import { cn } from '@/lib/utils';

const STATUS_STYLES: Record<TicketStatus, string> = {
  Pending: 'bg-zinc-500/15 text-zinc-700 dark:text-zinc-300',
  InProgress: 'bg-blue-500/15 text-blue-700 dark:text-blue-300',
  WaitingOnSomeone: 'bg-amber-500/15 text-amber-700 dark:text-amber-300',
  PendingSoftwareRelease: 'bg-purple-500/15 text-purple-700 dark:text-purple-300',
  Completed: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-300'
};

export const STATUS_LABELS: Record<TicketStatus, string> = {
  Pending: 'Pending',
  InProgress: 'In Progress',
  WaitingOnSomeone: 'Waiting on Someone',
  PendingSoftwareRelease: 'Pending Software Release',
  Completed: 'Completed'
};

/** Shared status pill used by both My Tickets and the IT Queue. */
export function StatusBadge({ status }: { status: TicketStatus }) {
  return (
    <span className={cn('inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium', STATUS_STYLES[status])}>
      {STATUS_LABELS[status]}
    </span>
  );
}
